var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.id
    ? _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm.loading
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col pr-1" }, [
                    _c("h2", { staticClass: "mb-0" }, [
                      _c(
                        "a",
                        { attrs: { href: _vm.permalink, target: "_blank" } },
                        [_vm._v(_vm._s(_vm.title))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto pl-1 pr-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-icon",
                        on: { click: _vm.clickEdit }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 13 13",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M0.668663 13.001C0.722663 13.001 0.776663 12.9944 0.829996 12.981L3.49666 12.3144C3.614 12.285 3.72133 12.2244 3.80666 12.139L12.002 3.94371C12.254 3.69171 12.3927 3.35705 12.3927 3.00105C12.3927 2.64505 12.254 2.31038 12.002 2.05838L10.9447 1.00105C10.4407 0.497047 9.56333 0.497047 9.05933 1.00105L0.863997 9.19638C0.778706 9.28178 0.718119 9.38867 0.688663 9.50571L0.0219966 12.1724C-0.00262832 12.2707 -0.00451965 12.3733 0.0164663 12.4724C0.0374522 12.5716 0.0807629 12.6646 0.143107 12.7445C0.205451 12.8244 0.285187 12.889 0.376255 12.9335C0.467323 12.9779 0.567326 13.001 0.668663 13.001ZM10.002 1.94371L11.0593 3.00105L10.002 4.05838L8.94466 3.00105L10.002 1.94371ZM1.93733 10.0084L8.002 3.94371L9.05933 5.00105L2.994 11.0657L1.58466 11.4177L1.93733 10.0084Z"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto pl-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary btn-icon",
                        attrs: { href: _vm.permalink }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "12",
                              viewBox: "0 0 14 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M13.7219 5.59688C12.2406 2.47656 10.0016 0.90625 7 0.90625C3.99687 0.90625 1.75937 2.47656 0.278124 5.59844C0.21871 5.72425 0.187897 5.86165 0.187897 6.00078C0.187897 6.13991 0.21871 6.27732 0.278124 6.40312C1.75937 9.52344 3.99844 11.0938 7 11.0938C10.0031 11.0938 12.2406 9.52344 13.7219 6.40156C13.8422 6.14844 13.8422 5.85469 13.7219 5.59688ZM7 9.96875C4.47969 9.96875 2.63437 8.69063 1.33281 6C2.63437 3.30938 4.47969 2.03125 7 2.03125C9.52031 2.03125 11.3656 3.30938 12.6672 6C11.3672 8.69063 9.52187 9.96875 7 9.96875ZM6.9375 3.25C5.41875 3.25 4.1875 4.48125 4.1875 6C4.1875 7.51875 5.41875 8.75 6.9375 8.75C8.45625 8.75 9.6875 7.51875 9.6875 6C9.6875 4.48125 8.45625 3.25 6.9375 3.25ZM6.9375 7.75C5.97031 7.75 5.1875 6.96719 5.1875 6C5.1875 5.03281 5.97031 4.25 6.9375 4.25C7.90469 4.25 8.6875 5.03281 8.6875 6C8.6875 6.96719 7.90469 7.75 6.9375 7.75Z",
                                fill: "white"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }, [
                  _vm.topic
                    ? _c("div", { staticClass: "col-auto" }, [
                        _c("i", {
                          staticClass: "fa fa-graduation-cap text-primary mr-1",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n          " + _vm._s(_vm.topic.name) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type
                    ? _c("div", { staticClass: "col-auto" }, [
                        _vm.type === "individueel"
                          ? _c("span", [
                              _c("i", {
                                staticClass: "fa fa-user text-primary mr-1",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" Open inschrijving")
                            ])
                          : _vm.type === "groepssessie"
                          ? _c("span", [
                              _c("i", {
                                staticClass: "fa fa-users text-primary mr-1",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" Teamtraining")
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto" }, [
                    _c("i", {
                      staticClass: "fa fa-money text-primary mr-1",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v("\n          € " + _vm._s(_vm.price) + "\n        ")
                  ])
                ]),
                _vm._v(" "),
                _vm.thumbnail
                  ? _c("img", {
                      staticStyle: { width: "100%", "object-fit": "cover" },
                      attrs: { src: _vm.thumbnail.url, alt: _vm.title }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", [_vm._v("Samenvatting")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.excerpt ? _vm.excerpt : "-"))]),
                _vm._v(" "),
                _c("h3", [_vm._v("Beschrijving")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.content ? _vm.content : "-"))]),
                _vm._v(" "),
                _c("h3", [_vm._v("Leerdoelen")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.leerdoelen ? _vm.leerdoelen : "-"))
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Doelgroep")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.doelgroep ? _vm.doelgroep : "-"))]),
                _vm._v(" "),
                _c("h3", [_vm._v("Talen")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.language && _vm.language.length > 0
                        ? _vm.language
                            .map(function(l) {
                              return _vm.option_language.find(function(ol) {
                                return ol.value === l
                              }).label
                            })
                            .join(", ")
                        : "-"
                    )
                  )
                ]),
                _c("p"),
                _c("h3", [_vm._v("Maximaal aantal deelnemers")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.max_participants
                        ? _vm.max_participants + " deelnemers"
                        : "-"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Trefwoorden")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "ul",
                    { staticClass: "trefwoorden" },
                    _vm._l(_vm.expertises, function(expertise) {
                      return _c("li", { key: expertise.term_id }, [
                        _vm._v(_vm._s(expertise.name))
                      ])
                    }),
                    0
                  )
                ])
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Sessies/Sessie.vue?vue&type=template&id=039caee8&
// module id = 366
// module chunks = 0